import api from "./axios";

// ---------------------------------------------------------------------------
// Phase A billing catalog (billing_plans + billing_prices)
// ---------------------------------------------------------------------------

export const get_billing_plansApi = (params = {}) => {
    return api.get("/admin/billing/plans", { params });
};

export const get_billing_planApi = (key) => {
    return api.get(`/admin/billing/plans/${key}`);
};

export const create_billing_planApi = (payload) => {
    return api.post("/admin/billing/plans", payload);
};

export const update_billing_planApi = (key, payload) => {
    return api.put(`/admin/billing/plans/${key}`, payload);
};

export const set_billing_plan_statusApi = (key, status) => {
    return api.post(`/admin/billing/plans/${key}/set-status`, { status });
};

export const get_billing_pricesApi = (params = {}) => {
    return api.get("/admin/billing/prices", { params });
};

export const create_billing_priceApi = (payload) => {
    return api.post("/admin/billing/prices", payload);
};

export const update_billing_priceApi = (priceId, payload) => {
    return api.put(`/admin/billing/prices/${priceId}`, payload);
};

export const set_billing_price_statusApi = (priceId, status) => {
    return api.post(`/admin/billing/prices/${priceId}/set-status`, { status });
};

export const get_billing_catalog_previewApi = (language = "en") => {
    return api.get("/admin/billing/catalog/preview", { params: { language } });
};

export const get_billing_settingsApi = () => {
    return api.get("/admin/billing/settings");
};

export const update_yearly_discountApi = (percentage) => {
    return api.put("/admin/billing/settings/yearly-discount", { percentage });
};

// ---------------------------------------------------------------------------
// Legacy user-scoped subscription plans (Assign Plan modal)
// ---------------------------------------------------------------------------

export const get_subscription_plansApi = (activeOnly = false) => {
    return api.get("/admin/billing/legacy-plans/", {
        params: { active_only: activeOnly },
    });
};

export const get_subscription_planApi = (planId) => {
    return api.get(`/admin/billing/legacy-plans/${planId}`);
};

export const create_subscription_planApi = (payload) => {
    return api.post("/admin/billing/legacy-plans/", payload);
};

export const update_subscription_planApi = (planId, payload) => {
    return api.put(`/admin/billing/legacy-plans/${planId}`, payload);
};

export const deactivate_subscription_planApi = (planId) => {
    return api.delete(`/admin/billing/legacy-plans/${planId}`);
};

export const get_subscription_plan_metadataApi = () => {
    return api.get("/admin/billing/legacy-plans/metadata/features");
};

// User Management still reads and assigns a user's plan.

export const get_user_subscriptionApi = (userId) => {
    return api.get(`/admin/billing/user-subscriptions/user/${userId}`);
};

export const assign_user_subscriptionApi = (payload) => {
    return api.post("/admin/billing/user-subscriptions/assign", payload);
};

export const list_polars_quota_requestsApi = (params = {}) => {
    return api.get("/admin/billing/polars-quota-requests/", { params });
};

export const approve_polars_quota_requestApi = (payload) => {
    return api.post("/admin/billing/polars-quota-requests/approve", payload);
};

export const reject_polars_quota_requestApi = (payload) => {
    return api.post("/admin/billing/polars-quota-requests/reject", payload);
};
